module.exports = __webpack_public_path__ + "models/tutor2.af24d66.atlas";